import { Topbar } from '../components/Topbar'
import { type PlaceholderPageProps } from '../constants/ui'

export function PlaceholderPage({
  title,
  subtitle = 'Coming soon',
}: PlaceholderPageProps) {
  return (
    <div className="overview-page">
      <Topbar title={title} subtitle={subtitle} />
      <section className="panel" style={{ padding: 24 }}>
        <p style={{ color: 'var(--text-muted)' }}>
          This section will be connected to live operations data next.
        </p>
      </section>
    </div>
  )
}
